// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"412":"b4c845a2","739":"95477f86"}[chunkId] + ".chunk.js";
};